"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero" ref={ref} className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/02/image_yeor0lee.png)] animate-zoom-in !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/04/ChatGPT-Image-Apr-30-2026-09_16_30-AM.png)] !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/04/ChatGPT-Image-Apr-30-2026-09_37_31-AM.png)] !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/04/ChatGPT-Image-Apr-30-2026-09_37_31-AM.png)] !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/04/ChatGPT-Image-Apr-30-2026-10_11_50-AM.png)]">
      <div className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        
      </div>

      <style jsx>{`
        @keyframes zoom-in {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }

        .animate-zoom-in {
          animation: zoom-in 10s ease-out forwards;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% center;
          }
          100% {
            background-position: 200% center;
          }
        }

        .shimmer-effect {
          position: relative;
          overflow: hidden;
        }

        .shimmer-effect::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          background-size: 200% 100%;
          animation: shimmer 2.5s infinite;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-zoom-in {
            animation: none;
            transform: scale(1);
          }
          .shimmer-effect::before {
            animation: none;
          }
        }
      `}</style>
    </section>;
}